import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { MapPin, Building, Calendar, Award } from "lucide-react";

export default function Projects() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/projects").then(r => setItems(r.data)); }, []);
  return (
    <div className="max-w-[1400px] mx-auto px-4 py-8">
      <h1 className="font-display text-3xl font-bold text-slate-900">Featured Projects</h1>
      <p className="text-slate-500 mt-1">Handpicked residential and commercial projects in Surat.</p>
      <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((p) => (
          <div key={p.id} data-testid={`project-card-${p.id}`} className="bg-white border border-slate-200 rounded-2xl overflow-hidden card-hover">
            <img src={p.image} alt={p.name} className="w-full h-52 object-cover"/>
            <div className="p-5">
              <h3 className="font-display font-semibold text-slate-900 text-lg">{p.name}</h3>
              <p className="text-xs text-slate-500">{p.developer}</p>
              <p className="flex items-center gap-1 text-sm text-slate-600 mt-2"><MapPin size={13}/> {p.location}</p>
              <p className="mt-2 text-sm text-slate-700">{p.description}</p>
              <div className="mt-3 grid grid-cols-2 gap-2 text-xs">
                <div><div className="text-slate-500">Starting from</div><div className="font-bold text-kp-maroon">{p.price_from}</div></div>
                <div><div className="text-slate-500">Configuration</div><div className="font-semibold text-slate-900">{p.configuration}</div></div>
                <div><div className="text-slate-500 flex items-center gap-1"><Calendar size={11}/> Possession</div><div className="font-semibold text-slate-900">{p.possession}</div></div>
                <div><div className="text-slate-500 flex items-center gap-1"><Award size={11}/> RERA</div><div className="font-semibold text-slate-900 truncate" title={p.rera}>{p.rera.slice(0, 20)}...</div></div>
              </div>
              <div className="mt-3 flex flex-wrap gap-1">
                {p.amenities.slice(0,4).map((a) => <span key={a} className="text-[10px] bg-kp-teal-light text-kp-teal px-2 py-0.5 rounded-full">{a}</span>)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
